import Vue from 'vue'

export default new Vue({
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    emitShow () {
      this.$set(this, 'isLoading', true)
    },
    emitHide () {
      this.$set(this, 'isLoading', false)
    },
    getLoadingStatus () {
      return this.isLoading
    }
  }
})
